import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';

const Toast = ({ toast, onClose }) => {
  return (
    <AnimatePresence>
      {toast && (
        <motion.div
          initial={{ opacity: 0, y: 50, scale: 0.9 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, scale: 0.9, transition: { duration: 0.2 } }}
          className="fixed bottom-6 right-6 z-[100] flex items-center gap-3 bg-espresso text-cream px-6 py-4 shadow-2xl rounded-sm border-l-4 border-moss"
          role="alert"
        >
          <div className="bg-moss/20 p-1.5 rounded-full">
            <SafeIcon name="Check" className="text-moss" />
          </div>
          <p className="text-sm font-medium pr-4">{toast.message}</p>
          <button 
            onClick={onClose}
            aria-label="Close notification"
            className="text-cream/50 hover:text-cream transition-colors ml-auto focus:outline-none focus-visible:ring-2 focus-visible:ring-moss"
          >
            <SafeIcon name="X" className="text-lg" />
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default Toast;